import { z } from 'zod';

export const baseBmpPerformanceFormSchema = z.object({
    percentage: z.number().min(0).nullable().optional(),
    date: z.date(),
});

export const createBmpPerformanceFormSchema = baseBmpPerformanceFormSchema
    .extend({
        userId: z.string().nonempty({ message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .superRefine((data, ctx) => {
        if (data.isTiedToAssessmentRun && !data.assessmentRunId) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Assessment run is required when tying to an assessment run',
                path: ['assessmentRunId'],
            });
        }
    });

export type CreateBmpPerformanceFormData = z.infer<typeof createBmpPerformanceFormSchema>;

export type EditBmpPerformanceFormData = z.infer<typeof baseBmpPerformanceFormSchema> & {
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const bmpPerformanceDefaultFormValues: CreateBmpPerformanceFormData = {
    percentage: null,
    date: new Date(),
    assessmentRunId: null,
    isTiedToAssessmentRun: false,
    userId: '',
};
